"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _I18n = _interopRequireDefault(require("I18n"));

var _UIButton = _interopRequireDefault(require("UIComponents/button/UIButton"));

var _UIDialogCloseButton = _interopRequireDefault(require("UIComponents/dialog/UIDialogCloseButton"));

var _UIDialogBody = _interopRequireDefault(require("UIComponents/dialog/UIDialogBody"));

var _UIDialogFooter = _interopRequireDefault(require("UIComponents/dialog/UIDialogFooter"));

var _UIModal = _interopRequireDefault(require("UIComponents/dialog/UIModal"));

var _H = _interopRequireDefault(require("UIComponents/elements/headings/H2"));

var _UIDialogHeader = _interopRequireDefault(require("UIComponents/dialog/UIDialogHeader"));

var ReviewModalSuccess = function ReviewModalSuccess(_ref) {
  var closeReviewModal = _ref.closeReviewModal;
  return _react.default.createElement(_UIModal.default, {
    size: "auto",
    use: "success"
  }, _react.default.createElement(_UIDialogHeader.default, null, _react.default.createElement(_UIDialogCloseButton.default, {
    onClick: closeReviewModal
  }), _react.default.createElement(_H.default, null, _I18n.default.text('reviewModal.reviewSubmitted.header'))), _react.default.createElement(_UIDialogBody.default, null, _I18n.default.text('reviewModal.reviewSubmitted.description')), _react.default.createElement(_UIDialogFooter.default, null, _react.default.createElement(_UIButton.default, {
    use: "primary",
    onClick: closeReviewModal
  }, _I18n.default.text('reviewModal.reviewSubmitted.button'))));
};

ReviewModalSuccess.propTypes = {
  closeReviewModal: _react.PropTypes.func.isRequired
};
var _default = ReviewModalSuccess;
exports.default = _default;
module.exports = exports.default;